export function Footer() {
  return (
    <footer className="bg-[#0B1017] border-t border-white/[0.05] px-8 lg:px-12 py-10">
      <div className="max-w-[1400px] mx-auto flex flex-wrap items-center justify-between gap-4">
        <div className="text-[12px] font-semibold tracking-[0.12em] uppercase text-white/35">
          LandTrack by Sowle Ventures
        </div>
        <div className="text-[12px] text-white/20">
          © {new Date().getFullYear()} Sowle Ventures. All rights reserved.
        </div>
        <div className="flex gap-6">
          <a
            href="#features"
            className="text-[12px] text-white/30 hover:text-white/70 transition-colors"
          >
            Features
          </a>
          <a
            href="#about"
            className="text-[12px] text-white/30 hover:text-white/70 transition-colors"
          >
            About
          </a>
          <a
            href="#contact"
            className="text-[12px] text-white/30 hover:text-white/70 transition-colors"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  )
}
